import { render, staticRenderFns } from "./getElectricshock1Second.vue?vue&type=template&id=74f72e8e&scoped=true&"
import script from "./getElectricshock1Second.vue?vue&type=script&lang=js&"
export * from "./getElectricshock1Second.vue?vue&type=script&lang=js&"
import style0 from "./getElectricshock1Second.vue?vue&type=style&index=0&id=74f72e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f72e8e",
  null
  
)

export default component.exports